import React from 'react';
import { Container, Title, Items, Item, ItemIcon, ItemText } from './StyledComponents';

//Animation
import Rotate from 'react-reveal/Rotate';
import Fade from 'react-reveal/Fade';
import Zoom from 'react-reveal/Zoom';

const index = (props) => {
    return (
        <>
            <Container>
                {(props.data.title.length > 0) && (<Title fontColor={props.data.fontColor}>{props.data.title}</Title>)}
                <Items>
                    {props.data.items.map((item, index) => (
                        <Item>
                            <Zoom cascade duration={1000}>
                                <ItemIcon src={item.icon}></ItemIcon>
                            </Zoom>
                            <Fade bottom cascade duration={2000}>
                                <ItemText fontColor={item.fontColor}>{item.text}</ItemText>
                            </Fade>
                        </Item>
                    ))}
                </Items>
            </Container>
        </>
    )
}

export default index
